import {
  LOAD_PROCESSED_ALERT_MESSAGES,
  UPDATE_MESSAGE,
  LOAD_PROCESSED_MESSAGES_DETAILS,
  SET_LAST_MESSAGES_LOAD_DATE,
} from '../actions/messagesActions';

function messages(
  state = {
    alertMessages: {},
    messageDetails: {},
    lastMessagesLoadDate: '',
  },
  action
) {
  switch (action.type) {
    // Load alert messages into the store
    case LOAD_PROCESSED_ALERT_MESSAGES:
      return {
        ...state,
        alertMessages: action.payload,
      };

    // Load the message details into the store
    // This creates a new part of state for each returned array of details that will then be referenced by the component
    case LOAD_PROCESSED_MESSAGES_DETAILS:
      return {
        ...state,
        messageDetails: {
          ...state.messageDetails,

          [`${action.payload.id}`]: action.payload.messages,
        },
      };
    case UPDATE_MESSAGE:
      return {
        ...state,
        alertMessages: {
          ...state.alertMessages,
          [`${action.payload.msgId}`]: action.payload,
        },
      };

    case SET_LAST_MESSAGES_LOAD_DATE:
      return {
        ...state,
        lastMessagesLoadDate: action.payload,
      };
    default:
      return state;
  }
}

export default messages;
